import { Api } from "../../Api/Api";

export const logOutAPi =()=> Api.delete('api/logout');